import styled from "styled-components";
import { ReactComponent as Circle } from "../assets/icons/circle.svg";
import "animate.css";
import AccountingImage from "../assets/images/accounting_bg.jpg";
import TaxImage from "../assets/images/tax_bg.jpg";
import FinanceImage from "../assets/images/finance_bg.jpg";
import ManagementImage from "../assets/images/manage_bg.jpg";
import SubTitle from "./SubTitle";

// 서비스 정보 객체
export const servicesData = {
  accounting: {
    title: "회계감사",
    description: "거래는 복잡하고 이해관계는 다변화하고 있으며 이에 따라 회계환경은 급변하고 있습니다. 재무제표에 신뢰를 부여하고 그 가치를 제고하는데 기여하는 회계감사는 매우 중요합니다. 회계법인 새시대는 열린 의사소통과 풍부한 감사 경험 그리고 품질 최우선 정책을 기반으로 이 중요한 회계감사를 제대로 잘할 수 있는 회계법인입니다.\n\n회계 관련 자문 업무는 복잡하고 해석의 다양성이 존재하는 경우나 인력의 부족으로 인해 회계 관련 전문가가 필요한 경우에 회계 관련 전문적 자문을 제공하는 업무입니다.",
    items: ["법정감사", "임의감사", "내부통제감사 업무대행"],
    image: AccountingImage,
    imageAlt: "회계감사 이미지"
  },
  tax: {
    title: "세무자문",
    description: "세금은 비즈니스에서 회피할 대상이 아니라 적극적으로 관리할 요소입니다. 세법 규정과 프랙티스의 입체적인 이해, 적극적이고 창의적인 마인드, 정확하고 체계적인 사실관계의 파악은 성공적인 조세 자문의 핵심입니다.",
    items: ["세무조사 업무대행", "세무대리", "세무조정", "조세불복", "장부기장 대행"],
    image: TaxImage,
    imageAlt: "세무자문 이미지"
  },
  finance: {
    title: "재무자문",
    description: "회계법인 새시대는 장부기장 대행, M&A 자문, 가치 평가, 기업지배구조 개편, 구조조정 등에서 고객의 기업가치를 극대화할 수 있는 최고의 자문 서비스를 제공하고 합니다.",
    items: ["M&A(분할 포함)", "가치평가 업무"],
    image: FinanceImage,
    imageAlt: "재무자문 이미지"
  },
  management: {
    title: "경영자문",
    description: "회계법인 새시대는 고도화되고 있는 회계환경 하에서 기업이 신뢰할 수 있는 회계정보를 산출하여 회계투명성을 향상시키고, 다양한 경영 자문을 통하여 고객에게 효과적이고 성공적인 방안을 제시합니다.",
    items: ["개인기업 법인전환", "기업진단", "IFRS 도입 및 자문", "법정관리(개인 및 기업회생)컨설팅", "사업비정산"],
    image: ManagementImage,
    imageAlt: "경영자문 이미지"
  }
};

// 공통 Styled Components
export const ServiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 80px;
  padding-bottom: 140px;
`;

export const ServiceContentContainer = styled.div`
  display: flex;
`;

export const ServiceContent = styled.div`
  width: 50%;
  line-height: 1.4;
  font-size: 16px;

  p {
    line-height: 1.8;
    animation: fadeInDown 1.5s forwards;
    word-break: keep-all;

    @keyframes fadeInDown {
      from {
        opacity: 0;
        transform: translateY(-30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
`;

export const ServiceListContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  animation: fadeInDown 1.5s forwards;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ServiceListTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
  > img {
    width: 10px;
    height: 10px;
  }

  > h5 {
    font-size: 20px;
  }
`;

export const ServiceList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 15px;
`;

export const ServiceListItem = styled.li`
  > span {
    margin-right: 10px;
  }
`;

export const ServiceImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  flex: 1;
`;

export const ServiceImageItem = styled.img`
  width: 100%;
  height: 100%;
  animation: fadeInRight 1.5s forwards;

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(40px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

// 공통 서비스 컴포넌트
const ServiceComponent = ({ serviceData }) => {
  const { title, description, items, image, imageAlt } = serviceData;

  const formattedDescription = description.split('\n').map((line, index) => (
    <span key={index}>
      {line}
      {index < description.split('\n').length - 1 && <br />}
    </span>
  ));

  return (
    <ServiceContainer>
      <SubTitle title={title} />
      <ServiceContentContainer>
        <ServiceContent>
          <p>{formattedDescription}</p>
          <ServiceListContainer>
            <ServiceListTitle>
              <Circle />
              <h5> 서비스 항목</h5>
            </ServiceListTitle>
            <ServiceList>
              {items.map((item, index) => (
                <ServiceListItem key={index}>
                  <span>-</span>{item}
                </ServiceListItem>
              ))}
            </ServiceList>
          </ServiceListContainer>
        </ServiceContent>
        <ServiceImageWrapper>
          <ServiceImageItem src={image} alt={imageAlt} />
        </ServiceImageWrapper>
      </ServiceContentContainer>
    </ServiceContainer>
  );
};

// 회계감사 컴포넌트
export const Accounting = () => {
  return <ServiceComponent serviceData={servicesData.accounting} />;
};

// 세무자문 컴포넌트
export const Tax = () => {
  return <ServiceComponent serviceData={servicesData.tax} />;
};

// 재무자문 컴포넌트
export const Finance = () => {
  return <ServiceComponent serviceData={servicesData.finance} />;
};

// 경영자문 컴포넌트
export const Management = () => {
  return <ServiceComponent serviceData={servicesData.management} />;
};
